
import React from "react";
import { i18nManager } from "../../../../../i18n";
import * as ReactRouterDom from "react-router-dom";
import { ApiResponseData, BaseService, ITournamentEdition, ITournamentEditionScoring, ITournamentEditionRegisteredParticipant, SanitizedResponse, TournamentService, ITournamentEditionScoringRecord, ITournamentEditionPrize, TournamentEditionScoringType, TournamentEditionScoringAppliesTo, ITournamentEditionScoreSetting } from "../../../../../services";
import { Elements } from "../../../../shared/Elements";
import { Schemes, Utils } from "../../../../../utils";
import Snapper from "../../../../shared/Snapper";
import { Table, TableSelectionMode, Classname, Column, DOMHelper, Scheme, ButtonManageRef, FormControl, TextInput, Checkbox, Dropdown, Form, DataManageRef, ObjectHelper, NumberInput, useScreenDimension } from "@rivtn/noseur";
import { ConfirmDialog, Siren } from "../../../../shared/ConfirmDialog";

interface ScoringProps {
    tournamentEdition: ITournamentEdition;
    dataComponentState: [React.ReactElement | undefined, React.Dispatch<React.SetStateAction<React.ReactElement | undefined>>];
}

function Scoring(props: ScoringProps) {

    const { tournamentEdition } = props;
    const { width } = useScreenDimension();
    const tournamentService = TournamentService.getInstance();
    const labels = i18nManager.Labels.host.manage_tournament.scoring;
    const [dataComponent, setDataComponent] = props.dataComponentState;
    const recordResultLeaderboardTableManageRef = React.useRef<DataManageRef>(null);
    const [tournamentPrizes, setTournamentPrizes] = React.useState<ITournamentEditionPrize[]>();
    const [searchParams, setSearchParams] = ReactRouterDom.useSearchParams(window.location.search);
    let [tournamentScoreRecords, setTournamentScoreRecords] = React.useState<ITournamentEditionScoringRecord[]>([]);
    const [tournamentCustomScorings, setTournamentCustomScorings] = React.useState<ApiResponseData<ITournamentEditionScoring> | undefined>({});

    React.useEffect(() => {
        //createOrUpdateCustomScore();
        tournamentService.getTournamentEditionPrizePool(tournamentEdition.external_id!).then(({ content }: SanitizedResponse<ITournamentEditionPrize>) => {
            setTournamentPrizes(content);
            fetchInformation();
        }).catch(BaseService.reportError);

        return () => {
            setDataComponent(undefined);
        };
    }, []);

    return (<div className="mt-participants">
        <div className="mt-query-section">
            <div style={{ display: "flex", alignItems: "center", marginBottom: 0, marginTop: 10, flex: 1, justifyContent: "flex-start" }}>
                {Elements.buildConfirmDialogForm(labels.query_inputs, (name, value) => {
                    Utils.updateSearchParams(name, value, setSearchParams, fetchInformation);
                }, {}, undefined, { flex: 0.5, marginTop: 0, flexDirection: "row", alignItems: "center" }, undefined, {
                    marginRight: 15, marginTop: 0
                })}
            </div>
            <div style={{ display: "flex" }}>
                <ReactRouterDom.Link className="link" style={{ marginRight: 20 }} to={`/hosts/${tournamentEdition.tournament.host.public_id}/create-tournament/${tournamentEdition.external_id}?section=SCORING_AND_TIE_BREAKING`}>{labels.edit_score_and_tie_breaker}</ReactRouterDom.Link>
                <span className="link" onClick={() => createOrUpdateCustomScore()} style={{ marginRight: 20 }}>{labels.add_custom_score}</span>
                <Snapper header={labels.all_scoring_overview_snap} template={[{ p: "tour_name", v: tournamentEdition.name }]} />
            </div>
        </div>
        <div className="mt-table-compound">
            <Table stripedRows scheme={Schemes.OMNEHOST} data={tournamentCustomScorings?.content} totalRecords={tournamentCustomScorings?.total_elements} dataRefreshKeys={["external_id", "created_at", "status"]}
                style={{ flex: 1, width: "100%" }} rowsPerPage={parseInt(searchParams.get("size") ?? "100")} loadingState={Elements.LOADING_STATE}
                selectionMode={TableSelectionMode.SINGLE} rowSelection={true} valuedRowProps={(d) => {
                    return {
                        className: Classname.build("host-tour-row", { "active": (dataComponent as any)?.key === d?.external_id })
                    };
                }} onRowSelection={(tournamentScore) => {
                    fetchScoreLeaderBoard(() => setDataComponent?.(buildTournamentScoreDetails(tournamentScore)));
                    return false;
                }}>
                <Column className="table-c" header={labels.table.headers.name} template={(v: ITournamentEditionScoring) => {
                    return (v.type === TournamentEditionScoringType.TOURNAMENT_SCORE ? "#" : v.name);
                }} />
                <Column className="table-c" header={labels.table.headers.type} template={(v: ITournamentEditionScoring) => {
                    return (v.type === TournamentEditionScoringType.TOURNAMENT_SCORE ? labels.detail.tournament_score : labels.detail.custom_score);
                }} />
                <Column className="table-c" header={labels.table.headers.leader} dataKey="leader" template={(v: ITournamentEditionRegisteredParticipant) => {
                    if (!v) return null;

                    const name = Utils.getResourceName(v.resource);
                    return (<div style={{ display: "flex", alignItems: "center" }}>
                        <img alt={name} src={Utils.getResourceImage(v.resource)} style={{ width: 20, height: 20, borderRadius: "100%", marginRight: 5 }} />
                        <span>{name}</span>
                    </div>);
                }} />
                <Column className="table-c" template={(v) => (<div style={{ display: "flex", alignItems: "center" }}>
                    <Snapper header={labels.score_leader_snap} style={{ marginRight: 20 }}
                        template={[{ p: "tour_name", v: tournamentEdition.name }]} />
                    <i className="fa fa-angle-right" />
                </div>)} />
            </Table>
        </div>
    </div>);

    function fetchInformation() {
        tournamentService.queryTournamentEditionScorings(tournamentEdition.external_id!, {

        }).then(({ apiResponse }: SanitizedResponse<ITournamentEditionScoring>) => {
            setTournamentCustomScorings(apiResponse.data!);
            //console.log("0000", tournamentPrizes);
            if (document.documentElement.clientWidth > 800 && apiResponse.data!.content?.length) {
                fetchScoreLeaderBoard(() => {
                    setDataComponent?.(buildTournamentScoreDetails(apiResponse.data!.content![0]!));
                });
            }
        }).catch(BaseService.reportError);
    }

    function fetchScoreLeaderBoard(done: () => void) {
        setTournamentScoreRecords([]);
        tournamentService.queryTournamentEditionScoringRecords(tournamentEdition.external_id!, {
            sort: "position,ASC",
        }).then(({ content }: SanitizedResponse<ITournamentEditionScoringRecord>) => {
            tournamentScoreRecords = content;
            setTournamentScoreRecords(content);
            done();
        }).catch(BaseService.reportError);
    }

    function renderLeaderboardTable(tournamentScore: ITournamentEditionScoring) {
        return (<Table stripedRows data={tournamentScoreRecords} scheme={Schemes.OMNEHOST} dataRefreshKeys={["external_id", "created_at"]}
            style={{ flex: 1, width: "100%", marginTop: 0, overflow: "auto" }} rowsPerPage={parseInt(searchParams.get("size") ?? "100")} loadingState={Elements.LOADING_STATE} >
            <Column className="table-c" header={labels.detail.table.headers.place} dataKey="position" />
            <Column className="table-c" header={labels.detail.table.headers.participant} dataKey="tournament_edition_registered_participant" template={(v) => {
                const name = Utils.getResourceName(v.resource);
                const imageUrl = Utils.getResourceImage(v.resource);

                return (<div style={{ display: "flex", alignItems: "center", width: "max-content" }}>
                    <Snapper header={labels.detail.participant_place_snap} template={[{ p: "tour_name", v: tournamentEdition.name }, { p: "participant_name", v: name }]} />
                    <img alt={name} src={imageUrl} style={{ width: 30, height: 30, margin: "0px 15px" }} />
                    <span>{name}</span>
                </div>);
            }} />
            {(Object.keys(tournamentScore.scoring).length > 0) ? (<React.Fragment key={DOMHelper.uniqueElementId("tslbo")}>
                {Object.values(tournamentScore.scoring).map((scoreSetting) => (<Column key={scoreSetting.id} className="table-c" header={scoreSetting.name} template={(v) => {
                    return (<span key={scoreSetting.id} style={{ marginTop: 5, width: "max-content" }}>{v.scores?.[scoreSetting.id]} {i18nManager.Labels.tournaments.your_tournament.home.scoring_system_map[scoreSetting.score_system.toLowerCase()]}</span>);
                }} />))}
            </React.Fragment>) : <Column />}
        </Table>);
    }

    function buildTournamentScoreDetails(tournamentScore: ITournamentEditionScoring) {
        const name = (tournamentScore.type === TournamentEditionScoringType.TOURNAMENT_SCORE ? "# " + labels.detail.tournament_score : tournamentScore.name);

        return (<div key={tournamentScore.external_id} className="mt-participant-data">
            <div className="mt-participant-data-hctrl">
                <Snapper header={labels.detail.score_overview_snap} template={[{ p: "tour_name", v: tournamentEdition.name }, { p: "name", v: name }]} />
                {(width < 800) && (<i className="fa fa-times close" onClick={() => setDataComponent?.(undefined)} />)}
            </div>
            <div className="mt-participant-data-details">
                <span className="n">{name}</span>
                <span className="d" style={{ opacity: 0.7 }}>{tournamentScore.applies_to === TournamentEditionScoringAppliesTo.INDIVIDUAL ? labels.detail.individual : labels.detail.participant}</span>
                <div className="prize-pool-prizes" style={{ display: "flex", marginTop: 10 }}>
                    {tournamentScore.tournament_prize_pool_ids?.map((prizeId) => tournamentPrizes?.find((tp) => tp.external_id === prizeId))?.map((prize) => {
                        if (!prize) return undefined;

                        return (<div>
                            {(prize.type === "TOP_WINNER") && (<span className="text-shadowed">{Utils.numberWithNth(prize.position)}</span>)}
                            <img alt={prize.title} src={prize.logo_url} />
                        </div>);
                    })}
                </div>
            </div>
            <div className="mt-participant-data-actions">
                <span className={Classname.build("link danger", { "noseur-disabled": tournamentScore.type === TournamentEditionScoringType.TOURNAMENT_SCORE })} onClick={() => deleteScore(tournamentScore)}>{labels.detail.delete}</span>
                <span className={Classname.build("link", { "noseur-disabled": tournamentScore.type === TournamentEditionScoringType.TOURNAMENT_SCORE })} onClick={() => createOrUpdateCustomScore(tournamentScore)}>{labels.detail.edit_scoring}</span>
                <span className="link" onClick={() => recordResults(tournamentScore)}>{labels.detail.record_result}</span>
            </div>
            <div className="mt-participant-data-hctrl" style={{ paddingTop: 15 }}>
                <Snapper header={labels.detail.score_leaderboard_snap} template={[{ p: "tour_name", v: tournamentEdition.name }, { p: "name", v: name }]} />
                <i className="fa fa-maximize close" onClick={() => {
                    showMaximizedScoreBoard?.(tournamentScore);
                }} />
            </div>
            {renderLeaderboardTable(tournamentScore)}
        </div>);
    }

    function showMaximizedScoreBoard(tournamentScore: ITournamentEditionScoring) {
        const dialogLabels = labels.dialog.maximize_leaderboard;
        const name = (tournamentScore.type === TournamentEditionScoringType.TOURNAMENT_SCORE ? "# " + labels.detail.tournament_score : tournamentScore.name);

        const dialog = ConfirmDialog({
            closable: true,
            noControl: true,
            maximized: true,
            forceClosable: true,
            style: { minWidth: "100%" },
            cancelLabel: i18nManager.Labels.common.close,
            desc: dialogLabels.desc.replace("${name}", name),
            title: dialogLabels.title.replace("${name}", name),
            content: (<div style={{ display: "flex", flexDirection: "column", padding: 0 }} className="mt-participant-data">
                <div className="mt-participant-data-hctrl" style={{ paddingTop: 15 }}>
                    <Snapper header={labels.detail.score_leaderboard_snap} template={[{ p: "tour_name", v: tournamentEdition.name }, { p: "name", v: name }]} />
                </div>
                {renderLeaderboardTable(tournamentScore)}
            </div>),
        });
        dialog.show();
    }

    function recordResults(tournamentScore: ITournamentEditionScoring) {
        const dialogErrorRef = { current: null } as any;
        const dialogLabels = labels.dialog.manually_record_score;
        const tournamentScoreRecording = [...tournamentScoreRecords];
        const name = (tournamentScore.type === TournamentEditionScoringType.TOURNAMENT_SCORE ? "# " + labels.detail.tournament_score : tournamentScore.name);

        async function reCalculatePositions(row: ITournamentEditionScoringRecord, scoreSetting: ITournamentEditionScoreSetting, newValue: number) {
            recordResultLeaderboardTableManageRef.current?.setLoadingState(true);
            const participantScoreIndex = tournamentScoreRecording.findIndex((s) => s.external_id === row.external_id);
            if (participantScoreIndex > -1) {
                const scoresKeys = Object.keys(row.scores);
                tournamentScoreRecording[participantScoreIndex].scores[scoreSetting.id] = newValue;
                tournamentScoreRecording.sort((a, b) => {
                    let diff = 0;
                    for (const scoreKey of scoresKeys) {
                        diff = b.scores[scoreKey] - a.scores[scoreKey];
                        if (diff !== 0) break;
                    }
                    return diff;
                });
                tournamentScoreRecording.forEach((e, i) => e.__new_position__ = (i + 1));
                recordResultLeaderboardTableManageRef.current?.setData(tournamentScoreRecording);
            }
            recordResultLeaderboardTableManageRef.current?.setLoadingState(false);
        }

        const dialog = ConfirmDialog({
            closable: true,
            title: dialogLabels.title,
            confirmLabel: dialogLabels.record_result,
            style: { maxWidth: "90%", minWidth: "50%" },
            desc: dialogLabels.desc.replaceAll("${name}", name),
            content: (<div style={{ margin: "10px 0px" }}>
                <Table stripedRows data={tournamentScoreRecording} manageRef={recordResultLeaderboardTableManageRef} scheme={Schemes.OMNEHOST} dataRefreshKeys={["external_id", "created_at", "place", "scores"]}
                    style={{ flex: 1, width: "100%", marginTop: 10, overflow: "auto" }} rowsPerPage={parseInt(searchParams.get("size") ?? "100")} loadingState={Elements.LOADING_STATE} >
                    <Column className="table-c" header={labels.detail.table.headers.new_place} template={(v) => {
                        return (<span style={{ fontWeight: "bold", color: "#25E157" }}>{v.__new_position__ ?? v.position}</span>);
                    }} />
                    <Column className="table-c" header={labels.detail.table.headers.old_place} template={(v) => {
                        return (<span style={{ fontWeight: "bold", color: "#FF7171" }}>{v.position}</span>);
                    }} />
                    <Column className="table-c" header={labels.detail.table.headers.participant} dataKey="tournament_edition_registered_participant" template={(v) => {
                        const name = Utils.getResourceName(v.resource);
                        const imageUrl = Utils.getResourceImage(v.resource);

                        return (<div style={{ display: "flex", alignItems: "center", width: "max-content" }}>
                            <Snapper header={labels.detail.participant_place_snap} template={[{ p: "tour_name", v: tournamentEdition.name }, { p: "participant_name", v: name }]} />
                            <img alt={name} src={imageUrl} style={{ width: 30, height: 30, margin: "0px 15px" }} />
                            <span>{name}</span>
                        </div>);
                    }} />
                    {(Object.keys(tournamentScore.scoring).length > 0) ? (<React.Fragment key={DOMHelper.uniqueElementId("tslbo")}>
                        {Object.values(tournamentScore.scoring).map((scoreSetting) => (<Column key={scoreSetting.id} className="table-c" header={scoreSetting.name} template={(v) => {
                            const score = v.scores?.[scoreSetting.id];
                            return (<>
                                <NumberInput scheme={Schemes.OMNEHOST} key={DOMHelper.uniqueElementId("scids")} defaultValue={score} style={{ marginRight: 7 }} onInputComplete={(value) => {
                                    if (!value) return;
                                    reCalculatePositions(v, scoreSetting, parseInt(value));
                                }} />
                                {i18nManager.Labels.tournaments.your_tournament.home.scoring_system_map[scoreSetting.score_system.toLowerCase()]}
                            </>);
                        }} />))}
                    </React.Fragment>) : <Column />}
                </Table>
                <div ref={dialogErrorRef} className="error" style={{ marginBottom: 10 }}> </div>
            </div>),
            onConfirm: async (button?: ButtonManageRef) => {
                button?.setLoadingState(true);
                tournamentService.updateTournamentEditionScoreRecording(tournamentEdition.external_id!, tournamentScore.external_id, tournamentScoreRecording.map((e) => ({
                    scores: e.scores,
                    external_id: e.external_id,
                    participant_name: Utils.getResourceName(e.tournament_edition_registered_participant.resource, e.tournament_edition_registered_participant.external_id)
                }))).then(({ }: SanitizedResponse<any>) => {
                    dialog.hide(() => {
                        setDataComponent(undefined);
                        fetchScoreLeaderBoard(() => setDataComponent?.(buildTournamentScoreDetails(tournamentScore)));
                    });
                }).catch((err) => {
                    button?.setLoadingState(false);
                    BaseService.reportError(err);
                });
                return false;
            }
        });
        dialog.show();
    }

    function createOrUpdateCustomScore(tournamentScore: Partial<ITournamentEditionScoring> = {}) {
        const isCreate = !tournamentScore?.external_id;
        const dialogErrorRef = { current: null } as any;
        const dialogLabels = labels.dialog.create_update;
        const subDialogLabels = i18nManager.Labels.host.create_tournament.scoring_and_tie_breaking;

        const dialog = ConfirmDialog({
            closable: true,
            style: { minWidth: "70%" },
            confirmLabel: (isCreate ? dialogLabels.create : dialogLabels.update),
            desc: (isCreate ? dialogLabels.create_desc : dialogLabels.update_desc),
            title: (isCreate ? dialogLabels.create_custom_score : dialogLabels.update_custom_score),
            content: (<div style={{ marginTop: 10, display: "flex", flexDirection: "column" }}>
                <a href={dialogLabels.what_is.location} target="_blank">{dialogLabels.what_is.label}</a>
                <FormControl scheme={Schemes.OMNEHOST} isFieldset fill label={dialogLabels.name} style={{ marginTop: 15 }}>
                    <TextInput defaultValue={tournamentScore?.name} scheme={Schemes.OMNEHOST} style={{ width: "100%" }} onInputComplete={(v) => {
                        dialogErrorRef.current!.innerText = " ";
                        tournamentScore.name = v;
                    }} />
                </FormControl>
                <Dropdown scheme={Schemes.OMNEHOST} fill formControlProps={{ className: "plan-dd", isFieldset: true, label: dialogLabels.applies_to, style: { marginTop: 10 } }}
                    options={dialogLabels.applies_to_options} selectedOptionIndex={dialogLabels.applies_to_options.findIndex((f) => f.value === tournamentScore.applies_to)} onSelectOption={(o) => {
                        tournamentScore.applies_to = o.value;
                    }} />
                <Dropdown scheme={Schemes.OMNEHOST} fill formControlProps={{ className: "plan-dd", isFieldset: true, label: dialogLabels.attach_trophy, style: { marginTop: 10 } }}
                    options={tournamentPrizes?.filter((p) => p.type === "TROPHY")} optionMap={{
                        label: "title",
                        icon: "logo_url",
                        value: "external_id",
                    }} selectedOptionIndex={tournamentPrizes?.findIndex((f) => tournamentScore.tournament_prize_pool_ids?.includes(f.external_id))} onSelectOption={(o) => {
                        tournamentScore.tournament_prize_pool_ids = [o.value];
                    }} />
                <Dropdown scheme={Schemes.OMNEHOST} fill formControlProps={{ className: "plan-dd", isFieldset: true, label: i18nManager.Labels.host.create_tournament.scoring_and_tie_breaking.choose_scoring_system, style: { marginTop: 10 } }}
                    options={i18nManager.Labels.host.create_tournament.scoring_and_tie_breaking.scoring_systems} optionTemplate={(option: any) => (<div key={option.value} style={{ display: "flex", flexDirection: "column" }}>
                        <span style={{ fontWeight: 500, marginBottom: 3, fontSize: 16 }}>{option.label}</span>
                        <span>{option.desc} <a target="_blank" href={option.article_link}>{i18nManager.Labels.host.create_tournament.scoring_and_tie_breaking.read_more}</a></span>
                    </div>)} selectedOptionIndex={i18nManager.Labels.host.create_tournament.scoring_and_tie_breaking.scoring_systems.findIndex((f) => f.value === "tournamentScore.score_system")} onSelectOption={(o) => {
                        // tournamentScore.score_system = o.value;
                    }} />
                <Checkbox scheme={Schemes.OMNEHOST} style={{ marginTop: 20 }} defaultChecked={tournamentScore.show_on_tournament_pages} label={dialogLabels.show_on_tour_public_pages} onChecked={(c) => {
                    tournamentScore.show_on_tournament_pages = c;
                }} />
                <div ref={dialogErrorRef} className="error" style={{ marginBottom: 10 }}> </div>
            </div>),
            rightContent: (<Form className="content" scheme={Schemes.OMNEHOST} style={{ borderLeft: "1px solid #E3E3E3", height: "100%", paddingLeft: 15, display: "flex", flexDirection: "column" }}>
                <span style={{ fontWeight: "bold" }}>{subDialogLabels.score_system}</span>
                <span style={{ marginTop: 10 }}>{subDialogLabels.score_system_info.label} <a target="_blank" href={subDialogLabels.score_system_info.article_link}>{subDialogLabels.score_system_info.read_more}</a></span>
                <Dropdown fill formControlProps={{ className: "plan-dd", isFieldset: true, label: subDialogLabels.choose_scoring_system, style: { marginTop: 10 } }}
                    options={subDialogLabels.scoring_systems} optionTemplate={(option: any) => (<div key={option.value} style={{ display: "flex", flexDirection: "column" }}>
                        <span style={{ fontWeight: 500, marginBottom: 3, fontSize: 16 }}>{option.label}</span>
                        <span>{option.desc} <a target="_blank" href={option.article_link}>{subDialogLabels.read_more}</a></span>
                    </div>)}
                    // selectedOptionIndex={subDialogLabels.scoring_systems.findIndex((f) => f.value === tournamentScore.score_system)} 
                    onSelectOption={(o) => {
                        //setTournament({ ...tournament, score_system: o.value });
                    }} />
                <span style={{ fontWeight: "bold", marginTop: 30 }}>{subDialogLabels.tie_breaker}</span>
                <span style={{ marginTop: 10 }}>{subDialogLabels.tie_breaker_info.label} <a target="_blank" href={subDialogLabels.tie_breaker_info.article_link}>{subDialogLabels.tie_breaker_info.read_more}</a></span>
                <Dropdown fill formControlProps={{ className: "plan-dd", isFieldset: true, label: subDialogLabels.select_tie_breaker_mechanism, style: { marginTop: 10 } }}
                    options={subDialogLabels.tie_breakers} optionTemplate={(option: any) => (<div key={option.value} style={{ display: "flex", flexDirection: "column" }}>
                        <span style={{ fontWeight: 500, marginBottom: 3, fontSize: 16 }}>{option.label}</span>
                        <span>{option.desc} <a target="_blank" href={option.article_link}>{subDialogLabels.read_more}</a></span>
                    </div>)} selectedOptionIndex={subDialogLabels.tie_breakers.findIndex((f) => f.value === tournamentScore.tie_breaker)} onSelectOption={(o) => {
                        //setTournament({ ...tournament, tie_breaker: o.value });
                        //setShowSecondaryScoreControl(o.value === "SECONDARY_SCORE_DIFFERENCE");
                    }} />
            </Form>),
            onConfirm: async (button?: ButtonManageRef) => {
                /*if (tournamentName !== registeredTournament.tournament.name) {
                    dialogErrorRef.current!.innerText = i18nManager.Labels.tournaments.dialog.confirm_tournament.name_does_not_match;
                    return false;
                }*/
                button?.setLoadingState(true);
                /*tournamentService.withdrawTournamentEditionRegistered(registeredTournament.external_id, reason).then(({ }: SanitizedResponse<any>) => {
                    dialog.hide(() => {
                        fetchTournaments();
                        Siren.alert(dialogLabels.withdrawal_request_submitted);
                    });
                }).catch(({ errorMessage }: any) => {
                    dialogErrorRef.current!.innerText = errorMessage;
                    button?.setLoadingState(false);
                });*/
                return false;
            }
        });
        dialog.show();
    }

    function deleteScore(tournamentScore: ITournamentEditionScoring) {
        let tournamentName = "";
        const dialogLabels = labels.dialog.delete;
        const dialogErrorRef = { current: null } as any;
        const name = (tournamentScore.type === TournamentEditionScoringType.TOURNAMENT_SCORE ? "# " + labels.detail.tournament_score : tournamentScore.name);

        const dialog = ConfirmDialog({
            closable: true,
            title: dialogLabels.title,
            confirmScheme: Scheme.DANGER,
            desc: dialogLabels.desc.replaceAll("${name}", name),
            content: (<div style={{ marginTop: 10, display: "flex", flexDirection: "column" }}>
                <a href={dialogLabels.see_how.location} target="_blank">{dialogLabels.see_how.label}</a>
                <span style={{ marginTop: 15 }}>{i18nManager.Labels.tournaments.dialog.confirm_tournament.to_continue}</span>
                <FormControl isFieldset fill label={i18nManager.Labels.tournaments.dialog.confirm_tournament.tour_name} style={{ marginTop: 15 }}>
                    <TextInput scheme={Schemes.OMNEHOST} style={{ width: "100%" }} onInputComplete={(v) => {
                        dialogErrorRef.current!.innerText = " ";
                        tournamentName = v;
                    }} />
                </FormControl>
                <div ref={dialogErrorRef} className="error" style={{ marginBottom: 10 }}> </div>
            </div>),
            onConfirm: async (button?: ButtonManageRef) => {
                if (tournamentName !== tournamentEdition.tournament.name) {
                    dialogErrorRef.current!.innerText = i18nManager.Labels.tournaments.dialog.confirm_tournament.name_does_not_match;
                    return false;
                }
                button?.setLoadingState(true);
                tournamentService.deleteTournamentEditionScoring(tournamentEdition.external_id, tournamentScore.external_id).then(({ }: SanitizedResponse<any>) => {
                    dialog.hide(() => {
                        fetchInformation();
                        setDataComponent?.(undefined);
                        Siren.alert(dialogLabels.successfully_deleted);
                    });
                }).catch(({ errorMessage }: any) => {
                    dialogErrorRef.current!.innerText = errorMessage;
                    button?.setLoadingState(false);
                });
                return false;
            }
        });
        dialog.show();
    }

}

export default Scoring;
